module.exports = __webpack_public_path__ + "static/3-d1a778bef2642bf6bba2405f5e71dade.png";